export const patient_routes = [
    {
      path: '/patient/:patient_uid',
      name: 'patient_layout',
      // Every route in this file inherits this via `matched`. These routes
      // carried NO meta at all, so the router guard skipped them entirely and
      // the chart stayed protected only because its own API calls 401'd — an
      // anonymous deep link got a blank chart and a toast instead of a login
      // prompt.
      //
      // No requiresLicense override on purpose: the chart is the product, and
      // it gets the same license gate as every other student surface
      // (StudentLayout, /cabinet). Overriding it here would let an unlicensed
      // student who is blocked from the activity deep-link straight to the
      // chart. The gate only fires for default_route === '/student' in a
      // paying org, so instructors and admins are unaffected.
      meta: { requiresAuth: true },
      component: () => import('src/layouts/PatientLayout.vue'),
      props: function (route) {
        return {
          preview: route.query.preview,
          patient_uid: route.params.patient_uid,
          grading: route.query.grading,
          simulation: route.query.simulation,
          visit_uid: route.query.visit_uid,
          version_uid: route.query.version_uid,
          activity_uid: route.query.activity_uid,
          course_uid: route.query.course_uid,
        }
      },
      children: [
        {
          path: '',
          name: 'patient_home',
          component: () => import('src/views/patient/PatientFlowsheet.vue'),
          props: function (route) {
            return {
              preview: route.query.preview,
              patient_uid: route.params.patient_uid,
              grading: route.query.grading,
              simulation: route.query.simulation,
              visit_uid: route.query.visit_uid,
              version_uid: route.query.version_uid,
              activity_uid: route.query.activity_uid,
              course_uid: route.query.course_uid,
            }
          },
        },
        {
          path: 'barcodes',
          name: 'patient_barcodes',
          component: () => import('../views/patient/PatientBarcodes.vue'),
          props: true
        },
        {
          path: 'flowsheet/patient_details',
          name: 'patient_details',
          component: () => import('../views/patient/PatientDetails.vue'),
          props: true
        },
        {
          path: 'visit_history',
          name: 'visit_history2',
          component: () => import('../views/patient/VisitHistory.vue')
        },
        {
          path: 'flowsheet/visit_history',
          name: 'visit_history',
          component: () => import('../views/patient/VisitHistory.vue'),
          props: function (route) {
            return {
              preview: route.query.preview,
              flowsheet_uid: route.params.flowsheet_uid,
              patient_uid: route.params.patient_uid,
              grading: route.query.grading,
              simulation: route.query.simulation,
              visit_uid: route.query.visit_uid,
              version_uid: route.query.version_uid,
              activity_uid: route.query.activity_uid,
              course_uid: route.query.course_uid,
            }
          },
        },
        {
          path: 'visit/:visit_uid',
          name: 'edit_visit',
          component: () => import('../views/patient/VisitDetails.vue'),
          props: true
        },
        {
          path: 'visit',
          name: 'new_visit',
          component: () => import('../views/patient/VisitDetails.vue'),
          props: function (route) {
            return {
              preview: route.query.preview,
              patient_uid: route.params.patient_uid,
              visit_uid: route.query.visit_uid,
              grading: route.query.grading,
              simulation: route.query.simulation,
              activity_uid: route.query.activity_uid,
              course_uid: route.query.course_uid,
              is_new: true,
            }
          }
        },
        {
          path: 'flowsheet/:flowsheet_uid',
          name: 'patient_flowsheet',
          component: () => import('../views/patient/PatientFlowsheet.vue'),
          props: function (route) {
            return {
              preview: route.query.preview,
              flowsheet_uid: route.params.flowsheet_uid,
              patient_uid: route.params.patient_uid,
              grading: route.query.grading,
              simulation: route.query.simulation,
              visit_uid: route.query.visit_uid,
              version_uid: route.query.version_uid,
              activity_uid: route.query.activity_uid,
              course_uid: route.query.course_uid,
              view: route.query.view
            }
          },
        },
        {
          path: 'new_event',
          name: 'new_event',
          component: () => import('../views/patient/EventDetails.vue'),
          props: true
        },
        {
          path: 'event',
          name: 'edit_event',
          component: () => import('../views/patient/EventDetails.vue'),
          props: true
        }
      ]
    }
]
